import { LeftArrowIcon, Typography } from '@gurupay/gp-ui-library';
import clsx from 'clsx';
import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

interface PageContainerProps {
	children?: ReactNode;
	title: string | ReactNode;
	icon?: ReactNode;
	backUrl?: string;
	isFullHeight?: boolean;
}

export const PageContainer: FC<PageContainerProps> = ({
	children,
	title,
	icon,
	backUrl,
	isFullHeight = true,
}) => {
	const navigate = useNavigate();
	const location = useLocation();
	const { t } = useTranslation();

	const handleBack = () => {
		if (location.key !== 'default') {
			navigate(-1);
			return;
		}

		if (backUrl) {
			navigate(backUrl);
		}
	};

	return (
		<div
			className={clsx(
				'rounded-lg w-full m-auto bg-neutral-white mx-0 p-space-32 max-mobile:p-space-16 max-mobile:rounded-lg',
				isFullHeight && 'min-h-[calc(100vh-96px)]',
			)}
		>
			<div className="flex gap-space-8 mb-space-40 max-mobile:mb-space-24 items-center">
				{!!backUrl && (
					<button
						aria-label={t('common.goBack')}
						className="cursor-pointer"
						onClick={handleBack}
						type="button"
					>
						<LeftArrowIcon className="text-neutral-600" />
					</button>
				)}
				{!!icon && <span className="text-brand-primary-700">{icon}</span>}
				<Typography className="text-xl-bold truncate flex-1" level="h2">
					{title}
				</Typography>
			</div>
			{children}
		</div>
	);
};
